import { css } from 'react-emotion'

const sizeStyle = ({ size }) =>
  css`
    width: ${size === 'lg' ? '54px' : '40px'};
    height: ${size === 'lg' ? '54px' : '40px'};
  `

export const round = ({ size } = {}) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 50%;

  svg {
    margin-left: 0;
  }

  ${sizeStyle({ size })};
`

export const square = ({ size } = {}) =>
  css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;

    svg {
      margin-left: 0;
    }

    ${sizeStyle({ size })};
  `



// WEBPACK FOOTER //
// ./src/styles/buttons.js